import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../utils/empty-reference';

export const DEFAULT_DESIGN_ID = 'temp-1';
export const DEFAULT_DESIGN_NAME = 'Vehicle Storage';

const DEFAULT_DESIGN = {
  Id: DEFAULT_DESIGN_ID,
  DesignName: DEFAULT_DESIGN_NAME,
  ProductTypeId: 15,
  Matrix: { Rows: 0, Columns: 0 },
  Products: [],
  Cart: [],
  Stacks: [],
  AnchorSide: 0,
};
export const _initialState = {
  design: {
    dragEvent: { isDragging: false, isVisualizerDrag: false },
    selectedProduct: null,
    selectedVisualizerStackId: null,
  },
  touchpoints: EMPTY_ARRAY,
  bundles: {
    added: EMPTY_ARRAY,
    data: null,
  },
  designs: {
    [DEFAULT_DESIGN_ID]: DEFAULT_DESIGN,
  },
  designIds: [DEFAULT_DESIGN_ID],
  selectedDesignId: DEFAULT_DESIGN_ID,
};
